import type { StatusFilter } from '@/components/organisms/payments/payments-shared';
import type {
  PaymentMethodFilter,
  PaymentSyncFilter,
  PaymentTableFilters,
} from '@/components/organisms/payments/PaymentsTableView';

export interface PaymentListFilters {
  q: string;
  status: StatusFilter;
  page: number;
  paymentMethod: PaymentMethodFilter;
  transactionId: string;
  amountOp: PaymentTableFilters['amount']['op'];
  amountValue: string;
  syncStatus: PaymentSyncFilter;
  dateFrom?: string;
  dateTo?: string;
}

// Mirror of the payments route `validateSearch` defaults (payments.tsx). Used to
// give cross-route navigations to `/dashboard/payments/$id` the full search shape
// the route expects — without it TanStack falls back to the index (the list).
export const DEFAULT_PAYMENT_LIST_FILTERS: PaymentListFilters = {
  q: '',
  status: 'ALL',
  page: 1,
  paymentMethod: 'ALL',
  transactionId: '',
  amountOp: 'eq',
  amountValue: '',
  syncStatus: 'ALL',
};
